<template>
  <v-card
    class="recognition-item px-4 py-3 d-flex align-start"
    elevation="0"
    :data-testid="`home-recognition-item-${recognition._id}`"
    :to="goToRecognition()"
    @click="
      trackRecognitionsNavigate({
        option: 'goToRecognition',
        section: 'home',
      })
    "
  >
    <div>
      <UserAvatar
        size="36px"
        fontSize="12px"
        :account="author"
        :imageSize="IMAGE_SIZES.MINI"
      />

      <UserAvatar
        v-if="accounts.length === 1"
        class="mt-n3"
        fontSize="12px"
        size="36px"
        :account="accounts[0]"
        :imageSize="IMAGE_SIZES.MINI"
      />
      <NumberAvatar
        v-else
        class="mt-n3"
        fontSize="12px"
        size="36px"
        :number="accounts.length"
      />
    </div>
    <div class="ms-2" style="max-width:85%;">
      <span class="caption blue-grey--text text--darken-1">
        {{ title }}
      </span>

      <p class="ma-0 pa-0 body-2 blue-grey--text text--darken-2 text-truncate">
        <template v-for="(chunk, i) in contentChunks">
          <span :key="i">
            <span
              v-if="REGEXES.MENTION.test(chunk)"
              class="primary--text font-weight-medium"
              >{{
                `${buildShortenedName(getAccountFromMention(chunk))} `
              }}</span
            >

            <template v-else>{{ `${chunk}` }}</template>
          </span>
        </template>
      </p>
    </div>
  </v-card>
</template>

<script>
import { mapGetters } from 'vuex'

import trackerMixin from '@/mixins/tracking/trackerMixin.vue'
import mixin from '@/mixins/mixin.vue'
import { IMAGE_SIZES } from 'rever-media-sdk'

import UserAvatar from '@/components/UserAvatar.vue'
import NumberAvatar from '@/components/NumberAvatar.vue'

const REGEXES = {
  SPACES_NOT_CONSIDERING_NEW_LINES: /(\s)/gm,
  MENTION: /@[0-9a-fA-F]{24}/,
  SPACED_MENTIONS: /@\s/g, // After translating a comment with mentions, the "@" character and the account id gets separated by Google Translate. We manually fix this using the "replace" method passing this regex as parameter.
}

export default {
  name: 'RecognitionItem',

  components: {
    UserAvatar,
    NumberAvatar,
  },

  mixins: [trackerMixin, mixin],

  data() {
    return {
      REGEXES,
      IMAGE_SIZES,
    }
  },

  computed: {
    ...mapGetters(['organizationId']),

    author() {
      return this.recognition?.createdBy
    },
    accounts() {
      return this.recognition?.accounts
    },

    title() {
      if (!this.recognition) return
      if (this.accounts?.length > 1) {
        return this.$t('home.activity_board.recognitions.card_title', {
          author: this.buildShortenedName(this.author),
          number: this.accounts.length,
        })
      }
      return this.$t('home.activity_board.recognitions.card_title_single', {
        author: this.buildShortenedName(this.author),
        person: this.buildShortenedName(this.accounts?.[0]),
      })
    },

    contentChunks() {
      return (
        this.recognition.content
          ?.replace?.(REGEXES.SPACED_MENTIONS, '@')
          .split?.(REGEXES.SPACES_NOT_CONSIDERING_NEW_LINES) ?? []
      )
    },
  },

  props: {
    recognition: {
      type: Object,
      required: true,
      default: null,
    },
  },

  methods: {
    buildShortenedName(accountData) {
      return accountData?.displayname
    },

    getAccountFromMention(mention) {
      const accountId = mention.slice(1)
      return (
        this.recognition.accounts.find(account => account._id === accountId) ??
        {}
      )
    },
    goToRecognition() {
      return `/recognitions?highlightedRecognition=${this.recognition._id}`
    },
  },
}
</script>
<style lang="scss" scoped>
.recognition-item:hover {
  background-color: $color-blue-grey-lighten3;
}
</style>
